<div class="component-viewer">
    <h1>Outing Permissions</h1>
        <mat-card >
            <mat-card-content>
                <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
                <gt-table *ngIf="true" [loading]="isLoading" [defaultPageSize]="10"
                    [updateFilterEvent]="updateFilterEvent" [filter]="filter" [data]="outingPermissionUsers"
                    (filterChanged)="getOutingPermissionUsers()" (filterReset)="resetFilter()">
                </gt-table>
                <table mat-table [dataSource]="outingPermissionUsers">
                    <ng-container matColumnDef="firstName">
                        <th mat-header-cell *matHeaderCellDef>First Name</th>
                        <td mat-cell *matCellDef="let user"> {{user.firstName}} </td>
                    </ng-container>
                    <ng-container matColumnDef="lastName">
                        <th mat-header-cell *matHeaderCellDef>Last Name</th>
                        <td mat-cell *matCellDef="let user"> {{user.lastName}} </td>
                    </ng-container>
                    <ng-container matColumnDef="addPermission">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let user">
                            <mat-form-field>
                                <mat-select placeholder="Add Permission" (selectionChange)="addOutingPermissionToUser($event.value, user)">
                                    <mat-option *ngFor="let permission of outingPermissionTypes" [value]="permission">{{permission.name}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="existingPermissions">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let user">
                            <mat-chip-listbox #chipList aria-label="Permissions">
                              <mat-chip-option selected *ngFor="let permission of user.userPermissions"
                                (removed)="removePermission(permission)">
                                {{permission.outingPermissionTypeName}}
                                <button matChipRemove>
                                  <mat-icon>cancel</mat-icon>
                                </button>
                              </mat-chip-option>
                            </mat-chip-listbox>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>
            </mat-card-content>
        </mat-card>
</div>


